
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { MessageCharacterCount } from '@/components/sms/shared/counters';

interface TemplateMessageInputProps {
  content: string;
  onChange: (content: string) => void;
  disabled?: boolean;
  characterCount: number;
  smsSegments: number;
  maxLength: number;
  textareaRef: React.RefObject<HTMLTextAreaElement>;
}

const TemplateMessageInput: React.FC<TemplateMessageInputProps> = ({
  content,
  onChange,
  disabled = false,
  characterCount,
  smsSegments,
  maxLength,
  textareaRef
}) => {
  return (
    <div className="grid gap-2">
      <div className="flex justify-between items-center">
        <Label htmlFor="template-content">Message Content</Label>
      </div>
      <Textarea 
        id="template-content"
        value={content}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Hey {firstName}, check out our weekend specials!"
        className="min-h-[120px]"
        ref={textareaRef}
        disabled={disabled}
      />
      
      <MessageCharacterCount 
        characterCount={characterCount}
        smsSegments={smsSegments}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TemplateMessageInput;
